import module from '../gift-list.module';
import _ from 'lodash';

module.factory('GiftListService', [
  '$resource',
  '$q',
  function ($resource, $q) {
    var resource = $resource('/api/gift-list/:personId', { personId: '@id' });
    var boughtByResource = $resource('/api/gift-list/bought-by-me');
    var suggestedByResource = $resource('/api/gift-list/suggested-by-me');

    return {
      listFor: function (personId) {
        var deferred = $q.defer();

        resource
          .query({ personId })
          .$promise.then((data) => {
            _.map(data, (gift) => {
              Object.defineProperty(gift, 'isBought', {
                get: function () {
                  return !!gift.boughtBy;
                },
              });
              Object.defineProperty(gift, 'requested', {
                get: function () {
                  return gift.giftFor == gift.suggestedBy;
                },
              });
            });
            deferred.resolve(data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      },
      suggestedBy: function (personId) {
        var deferred = $q.defer();

        suggestedByResource
          .query()
          .$promise.then((data) => {
            _.map(data, (gift) => {
              Object.defineProperty(gift, 'isBought', {
                get: function () {
                  return !!gift.boughtBy;
                },
              });
              Object.defineProperty(gift, 'requested', {
                get: function () {
                  return gift.giftFor == gift.suggestedBy;
                },
              });
            });
            deferred.resolve(data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      },
      boughtBy: function (personId) {
        var deferred = $q.defer();

        boughtByResource
          .query()
          .$promise.then((data) => {
            _.map(data, (gift) => {
              Object.defineProperty(gift, 'isBought', {
                get: function () {
                  return !!gift.boughtBy;
                },
              });
              Object.defineProperty(gift, 'requested', {
                get: function () {
                  return gift.giftFor == gift.suggestedBy;
                },
              });
            });
            deferred.resolve(data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      },
    };
  },
]);
